import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "242",
  "slug": "why-do-rivers-curve-geography-meanders",
  "title": "Why Rivers Meander, With an Example From the Mississippi",
  "excerpt": "River bends migrate as banks erode and sediment accumulates. Old channels can remain visible beside the active river.",
  "date": "2026-03-07",
  "category": "Geography",
  "image": "/blog-images/mississippi-meanders.jpg",
  "readTime": "2 min",
  "content": [
    {
      "type": "paragraph",
      "text": "River bends can grow as flowing water erodes an outer bank and deposits sediment along the inside of a bend. Over time the channel may migrate across its floodplain. If a new channel cuts across a narrow neck, part of the old loop can become separated from the main flow, forming an oxbow lake."
    },
    {
      "type": "paragraph",
      "text": "The result depends on the river's slope, sediment, banks, and flow. Not every river develops the same pattern: some have relatively straight reaches, and others split into braided channels around bars."
    },
    {
      "type": "heading",
      "text": "Read the Mississippi example"
    },
    {
      "type": "paragraph",
      "text": "In the photograph above, compare the pale active river with the yellow Arkansas–Mississippi state boundary. Near the centre, the river takes a shorter course past a bend still traced by the boundary. Nearby curves and disconnected water bodies preserve evidence of earlier channels."
    },
    {
      "type": "paragraph",
      "text": "NASA's photograph was taken from the International Space Station on 2 April 2020. North is to the left. The bright water is affected by sunglint, so its colour should not be read as a direct measurement of sediment concentration."
    },
    {
      "type": "heading",
      "text": "Trace a channel before naming the place"
    },
    {
      "type": "paragraph",
      "text": "Follow the connected watercourse through the frame. Then look for isolated arcs, curved strips of vegetation, and fields following older bends. Mark which features are visible and which require another image to confirm."
    },
    {
      "type": "paragraph",
      "text": "To investigate actual movement, compare dated views at a similar scale and season. One image can show an abandoned channel, but it cannot tell you exactly when the river left it. Water level, flood-control works, and differences in the imagery can also complicate the comparison."
    }
  ],
  "imageAlt": "Mississippi River bends and abandoned channels near Greenville, with the Arkansas–Mississippi boundary marked in yellow.",
  "imageCaption": "NASA / ISS Expedition 62, 2 April 2020. North is to the left. The yellow line marks the state boundary; the pale river channel no longer follows every bend of that boundary.",
  "sources": [
    {
      "title": "NASA: Meandering Mississippi River, photograph and explanation",
      "url": "https://science.nasa.gov/earth/earth-observatory/meandering-mississippi-river-147001/"
    }
  ]
};
